import es from 'lang/es.json'
import Head from 'next/head'
import React from 'react'
import HeroSection from '@components-pages/prestamos-calculadora/hero-section'
import LoanCalculatorSection from '@components-pages/prestamos-calculadora/loan-calculator-section'
import HeadMeta, { IHeadMetaComponent } from '@components/head-meta'
import { GetStaticPropsContext } from 'next'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

import type { NextPage } from "next";
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const CalculadoraPrestamos: NextPage = () => {
    const router = useRouter()
    const metaData: IHeadMetaComponent = {
      title: "loansCalculator",
      description: "LoanCalculator",
      url: router.asPath,
      og_type: "page-frequentQuestions",
    };
  return (
    <>
      <HeadMeta {...metaData}/>
      <HeroSection />
      <LoanCalculatorSection />
    </>
  );
};

export default CalculadoraPrestamos;
